import { render, staticRenderFns } from "./report-service-patients.vue?vue&type=template&id=4ffd7cce&"
import script from "./report-service-patients.vue?vue&type=script&lang=js&"
export * from "./report-service-patients.vue?vue&type=script&lang=js&"
import style0 from "./report-service-patients.vue?vue&type=style&index=0&id=4ffd7cce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports